<template>
  <main>
    <div class="sentence">
      <img src="./../assets/logo/Grupo 92.svg" width="35%" alt="osfatun" />
    </div>
    <section class="content">
      <h3 class="title mb-5 has-text-centered">
        ¡Hola {{ this.$store.state.name }}!
      </h3>

      <div v-if="cargado === false">
        <h5 class="title mb-5 has-text-centered">
          A continuación indique el afiliado, prestación y cargue la
          documentación relacionada a la misma.
        </h5>

        <div class="inputs-container">
          <!-- Documento del Afiliado -->
          <b-input
            class="custom-input"
            required
            type="text"
            v-model="documentoAfiliado"
            placeholder="Documento del Afiliado(solo numeros)"
          />

          <!-- Numero de Orden -->

          <b-input
            class="custom-input"
            required
            type="text"
            v-model="numeroOrden"
            placeholder="Numero de Orden (del autorizador)"
          />

          <!-- Codigo de practica -->

          <b-input
            class="custom-input"
            required
            type="text"
            v-model="codigoPractica"
            placeholder="Codigo de Practica (del nomenclador)"
          />

          <!-- Importe por practica -->

          <b-input
            class="custom-input"
            required
            type="number"
            v-model="importePractica"
            placeholder="Importe por Practica (sin decimales)"
          />

          <!-- Cantidad -->

          <b-input
            class="custom-input"
            required
            type="number"
            v-model="cantidad"
            placeholder="Cantidad (por ejemplo: 1, 5 o 10)"
          />
          <br />
        </div>

        <section class="section">
          <div class="container ">
            <b-upload
              v-model="files"
              :multiple="true"
              accept="image/*, application/pdf"
              drag-drop
              expanded
              icon-pack="fas"
              icon="cloud-upload-alt"
              required
            >
              <section class="section">
                <div class="file-upload">
                  <img src="../assets/add-files 1.png" alt="" />

                  <h5 class="m-5" v-if="files.length > 0">
                    Archivos Seleccionados
                  </h5>

                  <ul style="list-style: none" v-if="files.length > 0">
                    <img src="../assets/grupo24.png" alt="" />
                    <li v-for="(file, index) in files" :key="index">
                      {{ file.name }} - Cargado correctamente
                    </li>
                  </ul>
                  <p v-else>
                    Haga clic para sacarle una foto o abrir la librería de su
                    dispositivo y cargar la documentación de esta práctica.
                  </p>
                </div>
              </section>
            </b-upload>
          </div>
        </section>
        <b-loading
          :is-full-page="isFullPage"
          v-model="loading"
          :can-cancel="true"
        >
          <b-icon
            pack="fas"
            icon="sync-alt"
            size="is-large"
            custom-class="fa-spin"
          >
          </b-icon>
        </b-loading>

        <div v-if="cargado === false">
         
         
          <b-button
            class="button-new"
            type="is-info"
            @click="cargarDocumentos"
            :disabled="loading"
            ><img src="../assets/circle-plus 1.png" alt="" />
            Cargar Prestación
          </b-button>

          <br><br>

         
        </div>
      </div>
      <br />

      <div v-if="cargado === true">
        <h5 class="title mb-5 has-text-centered">
          Su prestacion ha sido presentada exitosamente.
        </h5>
      
        <b-button
            class="button-charge"
            type="is-info"
            @click="NuevaPrestacion"
            :disabled="loading"
            ><img src="../assets/circle-plus 1.png" alt="" />
            Cargar Nueva Prestación
          </b-button>

          <br><br>

        <router-link to="/exit" class="create">
          <b-button
          class="button-new"
            style="display: flex;"
            type="is-success"
            :disabled="loading"
          >
            <img src="../assets/check.png" alt="" style="max-width: 100%; max-height: 100%;" />FINALIZAR
          </b-button>
        </router-link>
        
      </div>
    </section>
    <Footer>
      <p class="m-2">Desarrollado por</p>
      <img src="../assets/logo/logozaro1.svg" alt="zaro" />
    </Footer>
  </main>
</template>

<script>
import axios from "axios";
import { mapMutations } from "vuex";
import { alertSuccess } from "@/helpers";
export default {
  data() {
    return {
      isFullPage: true,
      files: [],
      documentoAfiliado: "",
      numeroOrden: "",
      cantidad: "",
      importePractica: "",
      codigoPractica: "",
      cargado: false,
      loading: false,
      baseUrl: "https://api.osfatun.com.ar/",
      fileInputs: [],
    };
  },

  computed: {
    isFormValid() {
      return (
        this.documentoAfiliado &&
        this.numeroOrden &&
        this.cantidad &&
        this.importePractica &&
        this.codigoPractica &&
        this.files.length > 0
      );
    },
  },
  // ...
  methods: {
    async cargarDocumentos() {
      try {
        if (!this.isFormValid) {
          alert("complete todos los campos");
          return;
        }
        this.loading = true;

        // Recopilar datos de los inputs
        const formData = new FormData();
        formData.append("invoice_id", this.$store.state.id_invoice);
        formData.append("dni_afiliado", this.documentoAfiliado);
        formData.append("order_no", this.numeroOrden);
        formData.append("cuantity", this.cantidad);
        formData.append("amount", this.importePractica);
        formData.append("practice_code", this.codigoPractica);

        // Agregar los archivos cargados al FormData
        for (const file of this.files) {
          formData.append("archivos[]", file);
        }

        const token = this.$store.state.token;

        // Agregar el encabezado de autorización a la solicitud
        const config = {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`, // Agregar el token en el encabezado
          },
        };

        // Realizar la solicitud POST a la ruta del endpoint con los datos y archivos adjuntos
        const response = await axios.post(
          this.baseUrl + "api/v1/prestador/newInvoiceData",
          formData,
          config // Pasar el objeto de configuración con el encabezado de autorización
        );
        console.log(response);
        // Procesar la respuesta si es necesario
        alertSuccess("Carga Exitosa!");
        this.loading = false;
        this.cargado = true;
        //this.NuevaPrestacion()
      } catch (error) {
        console.error(error);
        this.loading = false;
        //alertFailed("Ocurrio un error al cargar los datos!");
      }
    },

   async  NuevaPrestacion(){
      this.cargado = false;

      this.files= "";
      this.documentoAfiliado= "";
      this.numeroOrden= "";
      this.cantidad= "";
      this.importePractica= "";
      this.codigoPractica= ""
 
    },

  

    ...mapMutations(["setToken", "setName", "setIdInvoice"]),
  },
};
</script>

<style>
.login-card {
  max-width: 400px; /* Ajusta el ancho del b-card */
}
</style>
<style scoped>
.sentence {
  background-image: url("./../assets/fondo.png");
  background-size: 100%;
  width: 100%;
  background-repeat: no-repeat;
  max-height: 33vh;
  padding: 2em;
}
.sentence img {
  padding: 1em;
  width: 220px;
  margin: 0 auto;
  text-align: center;
  display: block; 
}
.content {
  position: relative;
  max-width: 40%;
  padding: 40px 30px;
  margin: 0 auto;
}
h3.title {
  font-weight: bold;
  font-size: 34px;
  color: #00758f;
  line-height: 1.9rem;
  margin: 0 50px;
}
.inputs-container {
  display: flex;
  min-width: 300px;
  min-height: 280px;
  padding-bottom: 0px;
  flex-direction: column;
  justify-content: center;
}
.custom-input :placeholder-shown {
  color: black;
  background: rgb(228, 227, 227);
  border: 1px solid #bdbdbd;
}

.button-charge{
  vertical-align: middle; /* Alinear verticalmente la imagen con el texto */
    margin-right: 10px; 
    padding: 10px 20px;
}
.button-charge img{
  vertical-align: middle; /* Alinear verticalmente la imagen con el texto */
    margin-right: 10px; 
}

.control {
  padding: 5px;
}
.second-container {
  max-width: 90%;
  margin: 0 auto;
}
.hr {
  background-color: #eeeeee;
  margin: 50px 0;
}
h5.title {
  font-weight: 500;
  font-size: 14px;
  color: rgba(0, 0, 0, 1);
  margin-bottom: 6%;
}
.file-upload img {
  padding-bottom: 1em;
}
.file-upload {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px;
}
.button {
  background: rgba(0, 117, 143, 1);
}
.button text {
  padding-bottom: 100px;
  background: rgba(0, 117, 143, 1);
}
.create {
  display: flex; /* Usamos flexbox para alinear elementos internos */
  justify-content: center;
  padding: 1px;
}
.create p {
  display: flex; /* Usamos flexbox para alinear elementos internos */
  justify-content: center;
  padding: 1px;
}
.button-new{
  vertical-align: middle; /* Alinear verticalmente la imagen con el texto */
    margin-right: 10px; 
    padding: 10px 20px;
    background-color: #27AE60;
}
.button-new img{
  vertical-align: middle; /* Alinear verticalmente la imagen con el texto */
    margin-right: 10px; 
}

footer {
  display: flex;
  justify-content: center;
  margin-bottom: 1em;
  margin-top: 15em;

}

.button-next {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 1em;
}
.button-next h3{
  display: flex; /* Usamos flexbox para alinear elementos internos */
  justify-content: center;
  padding-top: 1px;
}
/* @media screen and (max-width: 1007px) {
  .sentence {
    background-image: url("./../assets/fondo.png");
    background-size: 100%;
    width: 100%;
    height: 60vh;
    background-repeat: no-repeat;
  }
}
.sentence img {
  margin: 0 auto;
  padding-top: 10%;
  text-align: center;
  display: inline-block;
}

.content {
  position: relative;

  background: white;
  max-width: 40%;
  padding: 40px 30px;
  margin: 0 auto;
} */


@media screen and (max-width: 42em) {
  .sentence {
    max-height: 15vh;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    padding: 3em;
  }
  .sentence img {
    width: 35%;
    position: relative;
    max-width: 100%;
    max-height: 100%;
    transform: translate(-50%, -50%);
    top: 40%;
    left: 15%;
    display: block;
    padding-bottom: 0;
  }

  .content {
    position: relative;
    background: white;
    max-width: 95%;
    padding: 40px 20px;
    margin: 1em auto;
  }
  
  h3.title {
    font-size: 29px;
    margin: 0;
  }
  h5.title{
    font-size: 15px;
  }
  .cont-h3 {
    margin: 0 2em;
  }
  footer {
    margin-top: 10em;
  }
}
</style>
